import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';
import { shouldShowField, validateField } from '../../../../components/InputField/helper';
import { DialogContext } from '../../../../store/context/DialogContext';
import { useTranslation } from '../../../../store/context/TranslationContext';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import { IPLUS_WIZARD } from '../IPlushelper';
import { getVisibleWizardFieldOrder } from '../components/IndividualLite/helper';

const IPlusAboutYou = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handleChange,
    handlePrev
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    useEffect(() => {
        const initialErrors = {};
        iPlusFields.forEach((field) => {
            if (
                field.required &&
                field?.wizard === wizard &&
                shouldShowField(data, field.showIf)
            ) {
                const value = _.get(data, field.field);
                if (value === undefined || value === null || value === "") {
                    if (value !== false && !_.get(errors, field.field)) {
                        _.set(initialErrors, field.field, field.errorTypes?.required || field.error || "This field is required.");
                    }
                }
            }
        });

        const shownErrors = {};
        iPlusFields.forEach((field) => {
            if (field?.wizard === wizard && shouldShowField(data, field.showIf)) {
                const value = _.get(data, field.field);
                const error = validateField(field, value, data);
                if (error) {
                    _.set(shownErrors, field.field, error);
                }
            }
        });

        setErrors(_.merge({}, shownErrors, initialErrors));
    }, [data, wizard, iPlusFields]);

    const checkNext = () => {
        const orderedFields = getVisibleWizardFieldOrder({ fields: iPlusFields, wizard, data });
        for (const fieldPath of orderedFields) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: { wizard: IPLUS_WIZARD.IPlusAccountActivityDeclaration }, payload: data });
        } else {
            return;
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    }

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    const setConversionValues = (type, sourceData = data) => {
        if (type == "Stablecoin") {

            const updatedDiffMap = {
                ...sourceData?.diffMap,
                Number_Of_Monthly_Stablecoin_Conversions_Deposits: sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Deposits ?? "",
                Amount_Of_Monthly_Stablecoin_Conversions_Deposits: sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Deposits ?? "",
                Number_Of_Monthly_Stablecoin_Conversions_Payments: sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Payments ?? "",
                Amount_Of_Monthly_Stablecoin_Conversions_Payments: sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Payments ?? "",
            }

            return {
                ...sourceData,
                Number_Of_Monthly_Stablecoin_Conversions_Deposits: 0,
                Amount_Of_Monthly_Stablecoin_Conversions_Deposits: 0,
                Number_Of_Monthly_Stablecoin_Conversions_Payments: 0,
                Amount_Of_Monthly_Stablecoin_Conversions_Payments: 0,
                diffMap: updatedDiffMap,
            };

        };

        if (type == "Cryptocurrency") {
            const countField = "Count_Of_Monthly_Cryptocurrency_Conversions";
            const amountField = "Amount_Of_Monthly_Cryptocurrency_Conversions";

            const updatedDiffMap = {
                ...sourceData?.diffMap,
                [countField]: sourceData?.selfDeclaredValues?.[countField] ?? "",
                [amountField]: sourceData?.selfDeclaredValues?.[amountField] ?? ""
            };
            return {
                ...sourceData,
                [countField]: 0,
                [amountField]: 0,
                diffMap: updatedDiffMap,
            };
        }

        return sourceData;
    };

    const clearConversionValues = (type, sourceData = data) => {

        if (type == "Stablecoin") {

            const updatedDiffMap = {
                ...sourceData?.diffMap,
                Number_Of_Monthly_Stablecoin_Conversions_Deposits: null,
                Amount_Of_Monthly_Stablecoin_Conversions_Deposits: null,
                Number_Of_Monthly_Stablecoin_Conversions_Payments: null,
                Amount_Of_Monthly_Stablecoin_Conversions_Payments: null,
            }

            return {
                ...sourceData,
                Number_Of_Monthly_Stablecoin_Conversions_Deposits: sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Deposits ?? "",
                Amount_Of_Monthly_Stablecoin_Conversions_Deposits: sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Deposits ?? "",
                Number_Of_Monthly_Stablecoin_Conversions_Payments: sourceData?.selfDeclaredValues?.Number_Of_Monthly_Stablecoin_Conversions_Payments ?? "",
                Amount_Of_Monthly_Stablecoin_Conversions_Payments: sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Stablecoin_Conversions_Payments ?? "",
                diffMap: updatedDiffMap,
            };

        };

        if (type == "Cryptocurrency") {

            const updatedDiffMap = {
                ...sourceData?.diffMap,
                Count_Of_Monthly_Cryptocurrency_Conversions: null,
                Amount_Of_Monthly_Cryptocurrency_Conversions: null
            }

            return {
                ...sourceData,
                Count_Of_Monthly_Cryptocurrency_Conversions: sourceData?.selfDeclaredValues?.Count_Of_Monthly_Cryptocurrency_Conversions ?? "",
                Amount_Of_Monthly_Cryptocurrency_Conversions: sourceData?.selfDeclaredValues?.Amount_Of_Monthly_Cryptocurrency_Conversions ?? "",
                diffMap: updatedDiffMap,
            };
        }

        return sourceData;
    };

    return (
        <div className='row pt-3'>
          

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["whyRequirePrimeAccount"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('whyRequirePrimeAccount', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["whyRequirePrimeAccountOther"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('whyRequirePrimeAccountOther', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["primeAccountUsage"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('primeAccountUsage', errorMsg)}
                isForEDD={isForEDD}
                className={'mb-2 px-1'}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["netWorthRange"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('netWorthRange', errorMsg)}
                isForEDD={isForEDD}
            />


            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["hasCoinConversionPlan"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('hasCoinConversionPlan', errorMsg)}
                isForEDD={isForEDD}
                customOperator={(v, nextData) => {
                    if (v === false)
                        handleUpdateFormData(setConversionValues("Stablecoin", nextData))
                    else if (v === true)
                        handleUpdateFormData(clearConversionValues("Stablecoin", nextData));
                }}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["hasCryptoConversionPlan"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('hasCryptoConversionPlan', errorMsg)}
                isForEDD={isForEDD}
                customOperator={(v, nextData) => {
                    if (v === false)
                        handleUpdateFormData(setConversionValues("Cryptocurrency", nextData));
                    else if (v === true)
                        handleUpdateFormData(clearConversionValues("Cryptocurrency", nextData));
                }}
            />

            <div className='mt-4'>
                <ButtonGroupNew
                    onNextClick={handleSubmit}
                    onBackClick={() => { handlePrev() }}
                    step={2}
                    hideSubmitButton={hideButtons}
                    showPageNum={false}
                    pageNum={2}
                    asLabel={false}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default IPlusAboutYou;
